import type { CrmMessages } from "./englishCrmMessages";

export const spanishCrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nombre de la empresa",
        website: "Web",
        linkedin_url: "URL de LinkedIn",
        phone_number: "Teléfono",
        created_at: "Creada el",
        nb_contacts: "Número de contactos",
        revenue: "Facturación",
        sector: "Sector",
        size: "Tamaño",
        tax_identifier: "CIF / NIF",
        address: "Dirección",
        city: "Población",
        zipcode: "Código postal",
        state_abbr: "Provincia",
        country: "País",
        description: "Descripción",
        context_links: "Enlaces de contexto",
        sales_id: "Responsable",
      },
      empty: {
        description: "Parece que todavía no hay empresas.",
        title: "No hay empresas",
      },
      import: {
        title: "Importar empresas",
      },
      field_categories: {
        contact: "Contacto",
        additional_info: "Información adicional",
        address: "Dirección",
        context: "Contexto",
      },
      action: {
        create: "Crear empresa",
        edit: "Editar empresa",
        new: "Nueva empresa",
        show: "Ver empresa",
      },
      added_on: "Añadida el %{date}",
      followed_by: "Responsable: %{name}",
      followed_by_you: "Responsable: tú",
      no_contacts: "Sin contactos",
      nb_contacts: "%{smart_count} contacto |||| %{smart_count} contactos",
      nb_deals: "%{smart_count} oportunidad |||| %{smart_count} oportunidades",
      sizes: {
        one_employee: "1 empleado",
        two_to_nine_employees: "2-9 empleados",
        ten_to_forty_nine_employees: "10-49 empleados",
        fifty_to_two_hundred_forty_nine_employees: "50-249 empleados",
        two_hundred_fifty_or_more_employees: "250 o más empleados",
      },
      autocomplete: {
        create_error: "Ha habido un error al crear la empresa",
        create_item: "Crear %{item}",
        create_label: "Empieza a escribir para crear una empresa",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      field_categories: {
        background_info: "Historial",
        identity: "Identidad",
        misc: "Otros",
        personal_info: "Datos de contacto",
        position: "Cargo",
      },
      fields: {
        first_name: "Nombre",
        last_name: "Apellidos",
        last_seen: "Última actividad",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Emails",
        email: "Email",
        phone_jsonb: "Teléfonos",
        phone_number: "Teléfono",
        linkedin_url: "URL de LinkedIn",
        background: "Notas de fondo (cómo nos conoció, contexto, etc.)",
        has_newsletter: "Recibe newsletter",
        sales_id: "Responsable",
      },
      action: {
        add: "Añadir contacto",
        add_first: "Añade tu primer contacto",
        create: "Crear contacto",
        edit: "Editar contacto",
        export_vcard: "Exportar a vCard",
        new: "Nuevo contacto",
        show: "Ver contacto",
      },
      background: {
        last_activity_on: "Última actividad el %{date}",
        added_on: "Añadido el %{date}",
        followed_by: "Responsable: %{name}",
        followed_by_you: "Responsable: tú",
        status_none: "Ninguno",
      },
      position_at: "%{title} en",
      position_at_company: "%{title} en %{company}",
      empty: {
        description: "Parece que todavía no hay contactos.",
        title: "No hay contactos",
      },
      import: {
        title: "Importar contactos",
      },
      inputs: {
        genders: {
          male: "Él",
          female: "Ella",
          nonbinary: "Elle",
        },
        personal_info_types: {
          work: "Trabajo",
          home: "Personal",
          other: "Otro",
        },
      },
      list: {
        error_loading: "Error al cargar los contactos",
      },
      bulk_tag: {
        action: "Etiquetar",
        back: "Volver a etiquetas",
        create_description:
          "Crea una etiqueta nueva y aplícala a los contactos seleccionados.",
        description:
          "Elige una etiqueta existente o crea una nueva para los contactos seleccionados.",
        empty:
          "Todavía no hay etiquetas. Crea una para etiquetar los contactos seleccionados.",
        error: "No se ha podido añadir la etiqueta",
        removed:
          "Etiqueta quitada de %{smart_count} contacto |||| Etiqueta quitada de %{smart_count} contactos",
        success:
          "Etiqueta añadida a %{smart_count} contacto |||| Etiqueta añadida a %{smart_count} contactos",
        title: "Añadir etiqueta a contactos",
      },
      merge: {
        action: "Fusionar con otro contacto",
        confirm: "Fusionar contactos",
        current_contact: "Contacto actual (se eliminará)",
        description: "Fusiona este contacto con otro.",
        error: "No se han podido fusionar los contactos",
        merging: "Fusionando...",
        no_additional_data: "No hay datos adicionales que fusionar",
        select_target: "Elige el contacto con el que fusionar",
        success: "Contactos fusionados",
        target_contact: "Contacto destino (se conserva)",
        title: "Fusionar contacto",
        warning_description:
          "Todos los datos pasarán al segundo contacto. No se puede deshacer.",
        warning_title: "Atención: acción irreversible",
        what_will_be_merged: "Qué se fusionará:",
      },
      filters: {
        before_last_month: "Antes del mes pasado",
        before_this_month: "Antes de este mes",
        before_this_week: "Antes de esta semana",
        managed_by_me: "Los míos",
        search: "Buscar nombre, empresa...",
        this_week: "Esta semana",
        today: "Hoy",
        tags: "Etiquetas",
        tasks: "Tareas",
      },
      hot: {
        empty_change_status:
          'Cambia el estado de un contacto añadiéndole una nota y pulsando "mostrar opciones".',
        empty_hint: 'Aquí aparecerán los contactos con estado "caliente".',
        title: "Contactos calientes",
      },
    },
    deals: {
      name: "Oportunidad |||| Oportunidades",
      fields: {
        name: "Nombre",
        description: "Descripción",
        company_id: "Empresa",
        contact_ids: "Contactos",
        category: "Categoría",
        amount: "Importe",
        expected_closing_date: "Fecha prevista de cierre",
        stage: "Etapa",
      },
      action: {
        back_to_deal: "Volver a la oportunidad",
        create: "Crear oportunidad",
        new: "Nueva oportunidad",
      },
      field_categories: {
        misc: "Otros",
      },
      filters: {
        only_mine: "Solo las mías",
      },
      archived: {
        action: "Archivar",
        error: "Error: no se ha archivado",
        list_title: "Oportunidades archivadas",
        success: "Oportunidad archivada",
        title: "Oportunidad archivada",
        view: "Ver archivadas",
      },
      inputs: {
        linked_to: "Vinculada a",
      },
      unarchived: {
        action: "Devolver al tablero",
        error: "Error: no se ha desarchivado",
        success: "Oportunidad desarchivada",
      },
      updated: "Oportunidad actualizada",
      empty: {
        before_create: "antes de crear una oportunidad.",
        description: "Parece que todavía no hay oportunidades.",
        title: "No hay oportunidades",
      },
      import: {
        title: "Importar oportunidades",
      },
      invalid_date: "Fecha no válida",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Estado",
        date: "Fecha",
        attachments: "Adjuntos",
        contact_id: "Contacto",
        deal_id: "Oportunidad",
      },
      action: {
        add: "Añadir nota",
        add_first: "Añade tu primera nota",
        delete: "Eliminar nota",
        edit: "Editar nota",
        update: "Actualizar nota",
        add_this: "Añadir nota",
      },
      sheet: {
        create: "Crear nota",
        create_for: "Crear nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota de %{name}",
      },
      deleted: "Nota eliminada",
      empty: "Todavía no hay notas",
      author_added: "%{name} añadió una nota",
      you_added: "Añadiste una nota",
      me: "Yo",
      list: {
        error_loading: "Error al cargar las notas",
      },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Entra en un contacto y añade una nota",
      },
      added: "Nota añadida",
      inputs: {
        add_note: "Añadir una nota",
        options_hint: "(adjuntar archivos o cambiar detalles)",
        show_options: "Mostrar opciones",
      },
      actions: {
        attach_document: "Adjuntar documento",
      },
      validation: {
        note_or_attachment_required: "Hace falta una nota o un adjunto",
      },
    },
    sales: {
      name: "Usuario |||| Usuarios",
      fields: {
        first_name: "Nombre",
        last_name: "Apellidos",
        email: "Email",
        secondary_email: "Email secundario",
        secondary_emails: "Emails secundarios",
        administrator: "Administrador",
        disabled: "Desactivado",
      },
      create: {
        error: "Ha habido un error al crear el usuario.",
        success: "Usuario creado. Recibirá un email para elegir su contraseña.",
        title: "Crear usuario",
      },
      edit: {
        error: "Ha habido un error. Inténtalo de nuevo.",
        record_not_found: "No encontrado",
        success: "Usuario actualizado",
        title: "Editar %{name}",
      },
      action: {
        new: "Nuevo usuario",
      },
    },
    tasks: {
      name: "Tarea |||| Tareas",
      forcedCaseName: "Tarea",
      fields: {
        text: "Descripción",
        due_date: "Fecha límite",
        type: "Tipo",
        contact_id: "Contacto",
        due_short: "vence",
      },
      action: {
        add: "Añadir tarea",
        create: "Crear tarea",
        edit: "Editar tarea",
      },
      actions: {
        postpone_next_week: "Pasar a la semana que viene",
        postpone_tomorrow: "Pasar a mañana",
        title: "acciones de la tarea",
      },
      added: "Tarea añadida",
      deleted: "Tarea eliminada",
      dialog: {
        create: "Crear tarea",
        create_for: "Crear tarea para %{name}",
      },
      sheet: {
        edit: "Editar tarea",
        edit_for: "Editar tarea de %{name}",
      },
      empty: "Todavía no hay tareas",
      empty_list_hint: "Aquí aparecerán las tareas de tus contactos.",
      filters: {
        later: "Más adelante",
        overdue: "Vencidas",
        this_week: "Esta semana",
        today: "Hoy",
        tomorrow: "Mañana",
        with_pending: "Con tareas pendientes",
      },
      regarding_contact: "(Sobre: %{name})",
      updated: "Tarea actualizada",
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: {
        add: "Añadir etiqueta",
        create: "Crear etiqueta",
      },
      dialog: {
        color: "Color",
        create_title: "Crear etiqueta",
        edit_title: "Editar etiqueta",
        name_label: "Nombre de la etiqueta",
        name_placeholder: "Escribe el nombre",
      },
      empty: "Todavía no hay etiquetas.",
    },
  },
  crm: {
    action: {
      reset_password: "Restablecer contraseña",
    },
    auth: {
      first_name: "Nombre",
      last_name: "Apellidos",
      confirm_password: "Confirmar contraseña",
      confirmation_required:
        "Abre el enlace que te acabamos de enviar por email para confirmar tu cuenta.",
      recovery_email_sent:
        "Si tienes cuenta, en breve recibirás un email para recuperar la contraseña.",
      sign_in_failed: "No se ha podido iniciar sesión.",
      sign_in_google_workspace: "Entrar con Google Workspace",
      signup: {
        create_account: "Crear cuenta",
        create_first_user:
          "Crea la primera cuenta de usuario para terminar la configuración.",
        creating: "Creando...",
        initial_user_created: "Usuario inicial creado",
      },
      welcome_title: "Bienvenido a Gula CRM",
    },
    common: {
      account_manager: "Responsable",
      activity: "Actividad",
      added: "añadido",
      details: "Detalles",
      last_activity_with_date: "última actividad %{date}",
      load_more: "Cargar más",
      misc: "Otros",
      past: "Pasadas",
      read_more: "Leer más",
      retry: "Reintentar",
      show_less: "Ver menos",
      copied: "¡Copiado!",
      copy: "Copiar",
      loading: "Cargando...",
      me: "Yo",
      task_count: "%{smart_count} tarea |||| %{smart_count} tareas",
    },
    changelog: {
      title: "Novedades",
    },
    activity: {
      added_company: "%{name} añadió la empresa",
      you_added_company: "Añadiste la empresa",
      added_contact: "%{name} añadió a",
      you_added_contact: "Añadiste a",
      added_note: "%{name} añadió una nota sobre",
      you_added_note: "Añadiste una nota sobre",
      added_note_about_deal: "%{name} añadió una nota sobre la oportunidad",
      you_added_note_about_deal: "Añadiste una nota sobre la oportunidad",
      added_deal: "%{name} añadió la oportunidad",
      you_added_deal: "Añadiste la oportunidad",
      at_company: "en",
      to: "a",
      load_more: "Ver más actividad",
    },
    dashboard: {
      deals_chart: "Ingresos previstos",
      deals_pipeline: "Embudo de oportunidades",
      latest_activity: "Actividad reciente",
      latest_activity_error: "Error al cargar la actividad reciente",
      latest_notes: "Mis últimas notas",
      latest_notes_added_ago: "añadida %{timeAgo}",
      stepper: {
        install: "Instalar Gula CRM",
        progress: "%{step}/3 hecho",
        whats_next: "¿Qué sigue?",
      },
      upcoming_tasks: "Próximas tareas",
    },
    data_import: {
      button: "Importar CSV",
      complete:
        "Importación terminada: %{importCount} registros importados, %{errorCount} errores",
      csv_file: "Archivo CSV",
      error:
        "No se ha podido importar el archivo. Comprueba que es un CSV válido.",
      in_progress: "Importando…",
      progress:
        "Importados %{importCount} / %{rowCount} registros, %{errorCount} errores.",
      remaining_time: "Tiempo restante estimado:",
      resource: "Recurso",
      sample_download: "Descargar CSV de ejemplo",
      sample_hint: "Aquí tienes un CSV de ejemplo para usar como plantilla",
      start: "Empezar importación",
      stop: "Parar importación",
      stopped:
        "Importación parada: %{importCount} registros importados, %{errorCount} errores",
      title: "Importar datos",
    },
    header: {
      import_data: "Importar desde JSON",
    },
    search: {
      title: "Buscar",
      placeholder:
        "Busca contactos, empresas, oportunidades, tareas y notas...",
      hint: "Escribe al menos %{min} caracteres para buscar",
      empty: "Sin resultados",
      error: "La búsqueda no está disponible ahora mismo. Inténtalo de nuevo.",
      untitled_result: "(sin título)",
      groups: {
        contacts: "Contactos",
        companies: "Empresas",
        deals: "Oportunidades",
        tasks: "Tareas",
        contact_notes: "Notas de contactos",
        deal_notes: "Notas de oportunidades",
      },
    },
    image_editor: {
      change: "Cambiar",
      drop_hint: "Arrastra un archivo para subirlo o haz clic para elegirlo.",
      editable_content: "Contenido editable",
      title: "Subir y recortar imagen",
      update_image: "Actualizar imagen",
    },
    import: {
      action: {
        download_error_report: "Descargar informe de errores",
        import: "Importar",
        import_another: "Importar otro archivo",
      },
      error: {
        unable: "No se ha podido importar el archivo.",
      },
      idle: {
        description_1:
          "Puedes importar usuarios, empresas, contactos, notas y tareas.",
        description_2:
          "Los datos deben ir en un archivo JSON como este ejemplo:",
      },
      status: {
        all_success: "Todos los registros se han importado.",
        complete: "Importación terminada.",
        failed: "Fallidos",
        imported: "Importados",
        in_progress: "Importando, no salgas de esta página.",
        some_failed: "Algunos registros no se han importado.",
        table_caption: "Estado de la importación",
      },
      title: "Importar desde JSON",
    },
    settings: {
      about: "Acerca de",
      companies: {
        sectors: "Sectores",
      },
      dark_mode_logo: "Logo en modo oscuro",
      deals: {
        categories: "Categorías",
        currency: "Moneda",
        pipeline_help: "Elige qué etapas cuentan como oportunidades en curso.",
        pipeline_statuses: "Etapas en curso",
        stages: "Etapas",
      },
      light_mode_logo: "Logo en modo claro",
      notes: {
        statuses: "Estados",
      },
      reset_defaults: "Volver a los valores por defecto",
      save_error: "No se ha podido guardar la configuración",
      saved: "Configuración guardada",
      saving: "Guardando...",
      tasks: {
        types: "Tipos",
      },
      preferences: "Preferencias",
      title: "Ajustes",
      app_title: "Nombre de la app",
      sections: {
        branding: "Marca",
      },
      validation: {
        duplicate: "%{display_name} duplicadas: %{items}",
        in_use:
          "No se pueden quitar %{display_name} que siguen en uso: %{items}",
        validating: "Comprobando…",
        entities: {
          categories: "categorías",
          stages: "etapas",
        },
      },
    },
    theme: {
      dark: "Oscuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    navigation: {
      label: "Navegación del CRM",
    },
    profile: {
      add_secondary_email: "Añadir email",
      email_taken: "%{email} ya lo usa otro usuario",
      no_secondary_emails: "Ninguno",
      secondary_email_invalid: "%{email} no es un email válido",
      secondary_email_is_primary: "%{email} ya es tu email principal",
      secondary_email_taken: "%{email} ya lo usa otro usuario",
      too_many_secondary_emails:
        "No puedes añadir más de 10 emails secundarios",
      secondary_emails_help:
        "Otras direcciones desde las que envías emails. Deja una vacía para quitarla.",
      inbound: {
        description:
          "Puedes enviar emails a la dirección de entrada del servidor, por ejemplo poniéndola en %{field}. El CRM procesará los emails y añadirá notas a los contactos.",
        title: "Email de entrada",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Usa esta URL para conectar tu asistente de IA a los datos del CRM mediante MCP (Model Context Protocol).",
      },
      password: {
        change: "Cambiar contraseña",
      },
      password_reset_sent:
        "Te hemos enviado un email para restablecer la contraseña",
      record_not_found: "No encontrado",
      title: "Perfil",
      updated: "Perfil actualizado",
      update_error: "Ha habido un error. Inténtalo de nuevo",
    },
    validation: {
      invalid_url: "Debe ser una URL válida",
      invalid_linkedin_url: "La URL debe ser de linkedin.com",
    },
  },
} satisfies CrmMessages;
